<template>
  <div class="">
<!--body content start-->

<div id="main-page" class="page-content">

<!--case studies single start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="owl-carousel no-pb" data-dots="false" data-items="1" data-autoplay="true">
          <div class="item">
            <img class="img-fluid w-100" src="images/cases/large/01.jpg" alt="">
          </div>
          <div class="item">
            <img class="img-fluid w-100" src="images/cases/large/02.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="dark-bg">
  <div class="container">
    <div class="portfolio-info">
      <div class="row align-items-center">
        <div class="col-lg-8 col-md-12 p-5">
         <h3 class="mb-3 text-white">Experience for Agency</h3>
          <p>A successful marketing plan relies heavily on the pulling-power of advertising copy. Writing result-oriented ad copy is difficult, as it must appeal to, entice, and convince consumers. Discover how we gave this startup a fresh visual start</p>
          <ul class="list-unstyled">
            <li class="mb-2">1. Strategic Discovery</li>
            <li class="mb-2">2. Web application redesign & optimization</li>
            <li class="mb-2">3. Mobile application redesign & optimization</li>
            <li class="mb-2">4. Landing page Template</li>
            <li>5. Component-based UI-kit</li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-12 p-5">
          <ul class="portfolio-meta list-unstyled">
            <li class="mb-4"><i class="flaticon-domain"></i>  <span class="text-white"> Category</span> Agency</li>
            <li class="mb-4"><i class="flaticon-support-1"></i>  <span class="text-white"> Client</span> ThemeHt</li>
            <li><i class="flaticon-experience"></i>  <span class="text-white"> Release</span> March, 2020</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<!--case studies single end-->


<!--case studies start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h6>Our Work</h6>
          <h2 class="title mb-0">Related <span>Case Studies</span></h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="owl-carousel" data-dots="false" data-nav="true" data-items="3" data-md-items="2" data-sm-items="1" data-margin="20" data-autoplay="true">
          <div class="item">
            <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/05.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Design</span>
              <h3><a href="case-studies-single.html">Experience for Agency</a></h3>
            </div> 
          </div>
        </div>
          </div>
          <div class="item">
            <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/06.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>UX/UI Design</span>
              <h3><a href="case-studies-single.html">Crafted with Love</a></h3>
            </div> 
          </div>
        </div>
          </div>
          <div class="item">
            <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/07.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Branding</span>
              <h3><a href="case-studies-single.html">Colibri Identity</a></h3>
            </div> 
          </div>
        </div>
          </div>
          <div class="item">
            <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/08.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Design</span>
              <h3><a href="case-studies-single.html">Experience for Agency</a></h3>
            </div> 
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--case studies end-->

</div>

<!--body content end--> 
  </div>
</template>

<script>


export default {
    data: function () {
        return {
            name: 'case-studies-single',
        }
    },
};
</script>
